export default "__VITE_ASSET__BprM5RQb__"